import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "dialog-box"
};
const _hoisted_2 = { class: "dialog-header" };
const _hoisted_3 = { class: "dialog-title" };
const _hoisted_4 = { class: "dialog-body" };
const _hoisted_5 = { class: "dialog-message" };
const _hoisted_6 = {
    key: 0,
    class: "dialog-input-wrapper"
};
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = { class: "dialog-actions" };
import { useDialogStore } from '@/IsekaiRPG/modules/ui/uiStores';
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GlobalDialog',
    setup(__props) {
        const dialogStore = useDialogStore();
        const inputRef = ref(null);
        const isCustomDialog = computed(() => dialogStore.type === 'custom');
        watch(() => dialogStore.isOpen, isOpen => {
            if (isOpen && dialogStore.type === 'prompt') {
                nextTick(() => {
                    inputRef.value?.focus();
                    inputRef.value?.select();
                });
            }
        });
        const handleConfirm = () => {
            dialogStore.confirm();
        };
        const handleCancel = () => {
            dialogStore.cancel();
        };
        const handleOverlayClick = () => {
            if (!dialogStore.closeOnOverlay) {
                return;
            }
            if (dialogStore.type !== 'alert') {
                dialogStore.cancel();
            }
            else {
                dialogStore.confirm();
            }
        };
        const handleKeydown = (event) => {
            if (event.key !== 'Escape' || !dialogStore.isOpen) {
                return;
            }
            if (dialogStore.type !== 'alert') {
                dialogStore.cancel();
            }
            else {
                dialogStore.confirm();
            }
        };
        onMounted(() => {
            window.addEventListener('keydown', handleKeydown);
        });
        onUnmounted(() => {
            window.removeEventListener('keydown', handleKeydown);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "dialog-fade" }, {
                default: _withCtx(() => [
                    (_unref(dialogStore).isOpen)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "global-dialog-overlay",
                            onClick: _withModifiers(handleOverlayClick, ["self"])
                        }, [
                            _createVNode(_Transition, {
                                name: "dialog-pop",
                                appear: ""
                            }, {
                                default: _withCtx(() => [
                                    (isCustomDialog.value && _unref(dialogStore).customComponent)
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(dialogStore).customComponent), _mergeProps({ key: 0 }, _unref(dialogStore).customProps, { onClose: handleCancel }), null, 16 /* FULL_PROPS */))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                            _createCommentVNode(" 标题栏 "),
                                            _createElementVNode("div", _hoisted_2, [
                                                _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(dialogStore).title), 1 /* TEXT */)
                                            ]),
                                            _createCommentVNode(" 内容区 "),
                                            _createElementVNode("div", _hoisted_4, [
                                                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(dialogStore).message), 1 /* TEXT */),
                                                (_unref(dialogStore).type === 'prompt')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            ref_key: "inputRef",
                                                            ref: inputRef,
                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(dialogStore).inputValue) = $event)),
                                                            type: "text",
                                                            class: "dialog-input",
                                                            placeholder: _unref(dialogStore).placeholder,
                                                            onKeyup: _withKeys(handleConfirm, ["enter"])
                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
                                                            [_vModelText, _unref(dialogStore).inputValue]
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createCommentVNode(" 底部按钮 "),
                                            _createElementVNode("div", _hoisted_8, [
                                                (_unref(dialogStore).type !== 'alert')
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "rpg-btn secondary",
                                                        onClick: handleCancel
                                                    }, _toDisplayString(_unref(dialogStore).cancelText), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                _createElementVNode("button", {
                                                    class: "rpg-btn primary",
                                                    onClick: handleConfirm
                                                }, _toDisplayString(_unref(dialogStore).confirmText), 1 /* TEXT */)
                                            ])
                                        ]))
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
